<template>
	<ActivityReviewCom />
</template>

<script>
import ActivityReviewCom from 'components/activityReview/activityReview';
export default {
  name: 'ActivityReview',

  components:{
    ActivityReviewCom
  },

  data () {
    return {
    }
  },

  computed: {

  },

  created() {
  },

  mounted() {},
}
</script>


<style lang='scss'>
</style>
